import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

const KEY = ["menu-categories"];

export const useMenuCategories = () => useQuery({ queryKey: KEY, queryFn: () => api("/menu-categories") });

export function useReorderMenuCategories() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (rows) => api("/menu-categories/reorder", { method: "POST", body: { ids: rows.map((r) => r.id) } }),
    onMutate: (rows) => { const prev = qc.getQueryData(KEY); qc.setQueryData(KEY, rows); return prev; },
    onError: (e, _rows, prev) => { qc.setQueryData(KEY, prev); toast.error(e.message); },
    onSuccess: () => toast.success("Ordem do cardápio salva"),
    onSettled: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

// Puts a reordered subset back into the full list, keeping the other items in their slots.
export function mergeOrder(full, subset) {
  const ids = new Set(subset.map((c) => c.id));
  const queue = [...subset];
  return full.map((c) => (ids.has(c.id) ? queue.shift() : c));
}

export function sortByMenuOrder(recipes, cats) {
  const idx = Object.fromEntries((cats || []).map((c, k) => [c.name.toLowerCase(), k]));
  const pos = (r) => idx[(r.menu_category || "").toLowerCase()] ?? 1e6;
  return [...recipes].sort((a, b) => pos(a) - pos(b) || a.name.localeCompare(b.name, "pt"));
}
